<template>
  <component 
    :is="tag"
    :class="[
      'animate-fade-in-up',
      textClass,
      gradientText ? 'text-transparent bg-gradient-to-r bg-clip-text' : '',
      gradientText ? gradientClass : ''
    ]"
    :style="{ 'animation-delay': delay }"
  >
    <span 
      v-for="(word, index) in words" 
      :key="index"
      :class="[
        'inline-block',
        animationType === 'slide-left' && index % 2 === 0 ? 'animate-slide-in-left' : '',
        animationType === 'slide-right' && index % 2 === 1 ? 'animate-slide-in-right' : '',
        animationType === 'scale' ? 'hover:scale-105 transition-transform duration-300 cursor-pointer' : '',
        wordSpacing
      ]"
      :style="{ 'animation-delay': `${parseFloat(delay) + index * 0.1}s` }"
    >
      {{ word }}
      <br v-if="breakWords && breakAfter.includes(index)" />
    </span>
    
    <!-- 特殊效果 -->
    <span 
      v-if="showCursor" 
      class="absolute -top-2 -right-2 w-3 h-3 bg-primary rounded-full animate-ping opacity-75"
    ></span>
    
    <!-- 发光效果 -->
    <span 
      v-if="glowEffect"
      class="absolute inset-0 bg-gradient-to-r from-primary/20 to-blue-500/20 blur-lg scale-110 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
    ></span>
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<{
  text: string;
  tag?: string;
  textClass?: string;
  animationType?: 'fade' | 'slide-left' | 'slide-right' | 'scale';
  delay?: string;
  gradientText?: boolean;
  gradientClass?: string;
  breakWords?: boolean;
  breakAfter?: number[];
  showCursor?: boolean;
  glowEffect?: boolean;
  wordSpacing?: string;
}>(), {
  tag: 'div',
  textClass: '',
  animationType: 'fade',
  delay: '0s',
  gradientText: false,
  gradientClass: 'from-primary to-primary/60',
  breakWords: false,
  breakAfter: () => [],
  showCursor: false,
  glowEffect: false,
  wordSpacing: 'mr-3'
});

const words = computed(() => {
  return props.text.split(' ');
});

// 解构props以便在模板中使用
const { 
  tag, 
  textClass, 
  animationType, 
  delay, 
  gradientText, 
  gradientClass, 
  breakWords, 
  breakAfter, 
  showCursor, 
  glowEffect, 
  wordSpacing 
} = props;
</script>

<style scoped>
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-fade-in-up {
  animation: fadeInUp 0.8s ease-out forwards;
  opacity: 0;
}

.animate-slide-in-left {
  animation: slideInLeft 0.8s ease-out;
}

.animate-slide-in-right {
  animation: slideInRight 0.8s ease-out;
}
</style>